// T134 Artefact 1 — hreflang alternates helper. Returns RR v7 MetaDescriptor[].
import type { MetaDescriptor } from "react-router";
import type { RouteKey } from "~/config/route-config";
import { absoluteUrl, SUPPORTED_LANGS } from "./site";

/**
 * `<link rel="alternate" hreflang>` for every supported locale plus an
 * `x-default` (→ ES, per spec). Emitting the full set on every page is what
 * tells LLMs and classic crawlers that the ES and EN URLs are the same page in
 * two languages — not two unrelated sites. Never throws.
 */
export function buildHreflang(
  routeKey: RouteKey,
  params?: Record<string, string>,
): MetaDescriptor[] {
  const links: MetaDescriptor[] = SUPPORTED_LANGS.map((lang) => ({
    tagName: "link",
    rel: "alternate",
    hrefLang: lang,
    href: absoluteUrl(routeKey, lang, params),
  }));
  links.push({
    tagName: "link",
    rel: "alternate",
    hrefLang: "x-default",
    href: absoluteUrl(routeKey, "es", params),
  });
  return links;
}
